/*
 * fn: initCookies
 *
 * Reads initial cookies and places them into HTML before first paint
 *
 * NOTE: Do NOT import anything into this function as it needs to be standalone to be injected into the document <head>
 *
 */
export const initCookies = () => {
  const r = document.documentElement
  const g = (key: string) => document.cookie.match(`(?:^|; )${key}=([^;]*)`)?.[1]
  const theme = g('theme')
  const ad = g('ad')
  const clipboard = g('clipboard')
  const filters = g('filters')
  const gallery = g('gallery')
  if (theme === 'light' || theme === 'dark') r.dataset.theme = theme
  if (ad === 'off') r.dataset.ad = ad
  if (clipboard === 'locked') r.dataset.clipboard = clipboard
  if (filters === 'locked') r.dataset.filters = filters
  if (gallery === 'locked') r.dataset.gallery = gallery
}
